import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  version(parameters={}) {
    parameters.appVersion = this.getAppVersion();
    parameters.platform   = utils.nativeCom.getUserAgentValue("platform");

    return core.call({
      url: '/api/v1/version',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getAppVersion() {
    var version = utils.nativeCom.getUserAgentValue("appVersion");
    if(version == '' || version == undefined) {
      return '1';  
    } else {
      return utils.nativeCom.getUserAgentValue("appVersion");
    }
  },
  setPushToken(parameters={}) {
    parameters.pushToken = decodeURIComponent(utils.nativeCom.getUserAgentValue("pushToken"));
    if(parameters.pushToken == '' || parameters.pushToken == undefined) {
      return;
    }

    return core.call({
      url: '/api/v1/setPushToken',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
}

